export const cantons = [
  { value: 0, label: 'ZH', labelLong: 'Zürich' },
  { value: 1, label: 'BE', labelLong: 'Bern' },
  { value: 2, label: 'LU', labelLong: 'Luzern' },
  { value: 3, label: 'UR', labelLong: 'Uri' },
  { value: 4, label: 'SZ', labelLong: 'Schwyz' },
  { value: 5, label: 'OW', labelLong: 'Obwalden' },
  { value: 6, label: 'NW', labelLong: 'Nidwalden' },
  { value: 7, label: 'GL', labelLong: 'Glarus' },
  { value: 8, label: 'ZG', labelLong: 'Zug' },
  { value: 9, label: 'FR', labelLong: 'Freiburg' },
  { value: 10, label: 'SO', labelLong: 'Solothurn' },
  { value: 11, label: 'BS', labelLong: 'Basel-Stadt' },
  { value: 12, label: 'BL', labelLong: 'Basel-Landschaft' },
  { value: 13, label: 'SH', labelLong: 'Schaffhausen' },
  { value: 14, label: 'AR', labelLong: 'Appenzell Ausserrhoden' },
  { value: 15, label: 'AI', labelLong: 'Appenzell Innerrhoden' },
  { value: 16, label: 'SG', labelLong: 'St. Gallen' },
  { value: 17, label: 'GR', labelLong: 'Graubünden' },
  { value: 18, label: 'AG', labelLong: 'Aargau' },
  { value: 19, label: 'TG', labelLong: 'Thurgau' },
  { value: 20, label: 'TI', labelLong: 'Tessin' },
  { value: 21, label: 'VD', labelLong: 'Waadt' },
  { value: 22, label: 'VS', labelLong: 'Wallis' },
  { value: 23, label: 'NE', labelLong: 'Neuenburg' },
  { value: 24, label: 'GE', labelLong: 'Genf' },
  { value: 25, label: 'JU', labelLong: 'Jura' },
]
  .sort((a, b) => a.label.localeCompare(b.label))
  .map((canton, index) => {
    return { ...canton, value: index }
  })
